<style>
.endereco-table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 15px !important;
}

.endereco-table td {
    padding: 3px 5px;
    border: 1px solid #728cc0;
}

.endereco-table td.label {
    text-align: left;
    font-weight: bold;
    font-size: 10pt;
    text-transform: uppercase;
    border-right: none;
}

.endereco-table td.info {
    border-left: none;
    text-align: center;
}

.endereco-table tr:last-child td:last-child {
    border-bottom: none;
    border-right: none;
}

.endereco-table tr:last-child td:first-child {
    border-bottom: none;
    border-left: none;
}

.title-table td {
    background: #002B82;
    color: #FFF;
    text-align: center;
    vertical-align: middle;
    height: 35px;
}

.title-table td:first-child {
    text-align: left;
    padding-left: 10px;
}

.title-table td:last-child {
    text-align: right;
    padding-right: 10px;
}

.carousel-table {
    width: 100%;
}

.carousel-table td {
    text-align: center;
}

.carousel-button-td {
    width: 5%;
    font-size: 20pt;
    color: #000084;
}

.carousel-button-td button {
    padding: 3px 12px;
    font-size: 15pt;
}

.carousel-table td:first-child {
    padding-right: 10px;
}

.carousel-table td:last-child {
    padding-left: 10px;
}

.mcarousel-item {
    /* border: 1px solid #000; */
}

.carousel-btn {
    padding: 7px 15px !important;
    margin-bottom: 0px !important;
}

.carousel-control {
    margin-top: 15px;
}

.carousel-control td {
    text-align: center;
    vertical-align: middle !important;
    padding: 0px 10px;
}
</style>

<template>
    <div class="card card-plain"
        style="margin: 0 auto; max-width: 450px; background: #FFF; -webkit-box-shadow: 39px 55px 0px -4px rgba(0,0,0,0.75); -moz-box-shadow: 39px 55px 0px -4px rgba(0,0,0,0.75); box-shadow: 39px 55px 0px -4px rgba(0,0,0,0.75);">
        <div class="pb-0 card-header text-start">
            <h4 class="font-weight-bolder">Meus contratos</h4>
            <p class="mb-0" style="line-height: 1.3">
                Você possui <b>{{ contratos.length }} {{ contratos.length > 1 ? 'contratos' : 'contrato' }}</b> aguardando
                ativação.
            </p>
            <p class="mb-0" style="margin-top: 5px;">
                Escolha abaixo o contrato que deseja ativar:
            </p>
        </div>
        <div class="card-body" style="padding-bottom: 10px; padding-top: 10px;">


            <div v-for="(contrato, index) in contratos" :key="index">
                <div v-if="index === carousel.selectedIndex">
                    <div style="border: 2px solid #002B82; border-radius: 5px;">

                        <table class="title-table" style="width: 100%;">
                            <tr>
                                <td>
                                    <b>Contrato #{{ contrato.id_contrato }}</b>
                                </td>
                                <td>
                                    <b v-if="contrato.download.replace(/\D/g, '') != 1">{{ contrato.download.replace(/\D/g,
                                        '') }} MEGA</b>
                                    <b v-if="contrato.download.replace(/\D/g, '') == 1">DEDICADO</b>
                                </td>
                            </tr>
                        </table>


                        <table class="endereco-table">
                            <tr>
                                <td class="label">
                                    Endereço
                                </td>
                                <td class="info">
                                    {{ contrato.endereco }}
                                </td>
                            </tr>
                            <tr>
                                <td class="label">
                                    Número
                                </td>
                                <td class="info">
                                    {{ contrato.numero }}
                                </td>
                            </tr>
                            <tr>
                                <td class="label">
                                    Bairro
                                </td>
                                <td class="info">
                                    {{ contrato.bairro }}
                                </td>
                            </tr>
                            <tr>
                                <td class="label">
                                    Cidade
                                </td>
                                <td class="info">
                                    {{ contrato.cidade }} - {{ contrato.uf }}
                                </td>
                            </tr>
                            <tr>
                                <td class="label">
                                    Valor
                                </td>
                                <td class="info">
                                    {{ contrato.valor_final_contrato.toLocaleString('pt-BR', {
                                        style: 'currency', currency:
                                            'BRL'
                                    }) }}
                                    <span v-if="temDescontoPix(contrato)" class="text-success-dark text-lg text-bold">*</span>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2" align="center" style="padding: 10px 0px;">
                                    <argon-button variant="gradient" color="warning" size="sm"
                                        @click="ativarContrato(contrato)">ATIVAR</argon-button>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>

            <table v-if="contratos.length > 1" class="carousel-control">
                <tr>
                    <td>
                        <button :disabled="carousel.selectedIndex < 1" class="btn btn-primary carousel-btn"
                            @click="prevItem()">
                            <font-awesome-icon icon="fa-solid fa-chevron-left" />
                        </button>
                    </td>

                    <td>
                        {{ carousel.selectedIndex + 1 }}/{{ contratos.length }}
                    </td>

                    <td>
                        <button :disabled="carousel.selectedIndex >= contratos.length - 1"
                            class="btn btn-primary carousel-btn" @click="nextItem()">
                            <font-awesome-icon icon="fa-solid fa-chevron-right" />
                        </button>
                    </td>
                </tr>
            </table>

        </div>
        <div class="px-1 pt-0 text-center card-footer px-lg-2">
            <div v-if="temDescontoPix(contratos[carousel.selectedIndex])" class="w-100 text-center mb-2" style="line-height: 1">
                <span class="text-success-dark text-lg text-bold">*</span>
                <span class="text-success-dark text-sm text-bold">
                    Pagamentos via PIX terão um desconto de R$4,90 na mensalidade deste contrato
                </span>
            </div>
            <p class="mx-auto text-sm">
                Dúvidas?
                <a href="https://api.whatsapp.com/send?phone=553537311118" class="text-warning text-gradient font-weight-bold">Entre em contato pelo WhatsApp</a>
            </p>
            <button class="btn btn-light btn-sm mb-0" @click="voltar">VOLTAR</button>
        </div>
    </div>
</template>
  
<script>
import ArgonButton from "@/components/ArgonButton.vue";
const body = document.getElementsByTagName("body")[0];
import { decode } from '../services/jwt.js'

let carousel = {
    selectedIndex: 0
}

const contratos = [];

export default {
    name: "Contratos",
    components: {
        ArgonButton
    },
    methods: {
        prevItem() {
            this.carousel.selectedIndex--;
            if (this.carousel.selectedIndex < 0)
                this.carousel.selectedIndex = 0;
        },
        nextItem() {
            this.carousel.selectedIndex++;
            if (this.carousel.selectedIndex > this.contratos.length - 1)
                this.carousel.selectedIndex = this.contratos.length - 1;
        },
        ativarContrato(contrato) {
            localStorage.setItem('contratoAtivando', JSON.stringify(contrato))
            this.$router.push({ name: 'Confirmar' })
        },
        voltar() {
            this.$router.push({ name: 'Inicio' })
        },
        temDescontoPix(contrato) {
            // Planos que começam com "1.25" possuem desconto de R$4,90 ao pagar via PIX
            return contrato.plano_venda && contrato.plano_venda.startsWith('1.25')
        }
    },
    data() {
        return {
            contratos,
            carousel
        }
    },
    computed() {

    },
    beforeMount() {
        const contratosPendentes = JSON.parse(localStorage.getItem('contratosPendentes'))

        this.contratos = contratosPendentes
    },
    created() {
        this.$store.state.hideConfigButton = true;
        this.$store.state.showNavbar = false;
        this.$store.state.showSidenav = false;
        this.$store.state.showFooter = false;
        body.classList.remove("bg-gray-100");
    },
    beforeUnmount() {
        this.$store.state.hideConfigButton = false;
        this.$store.state.showNavbar = true;
        this.$store.state.showSidenav = true;
        this.$store.state.showFooter = true;
        body.classList.add("bg-gray-100");
    },
};
</script>
  